import {
  GlobalDesignActionType,
  GlobalDesignGroupAction,
  ComparisonMode,
} from '../types';
import { getBaseManifestProcessingStrategy } from '../common/grouping/getBaseManifestProcessingStrategy';
import { borderGrouping } from './grouping';
import BorderLobbyItem from './BorderLobbyItem';
import BorderStyles from './BorderStyles';
import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import { borderGroupDisplayFilter } from './groupDisplayFilter';
import { Meaningfulness } from '../../../apis/services/editActionsServices/nativeActions/globalDesign/common/meaningfulnessPredicates';
import { BORDER_WIDTH_CSS_PROPERTY_TYPES } from '../../../apis/services/editActionsServices/nativeActions/globalDesign/constants';

const borderAction: GlobalDesignGroupAction = {
  type: GlobalDesignActionType.Group,
  panel: BorderStyles,
  lobbyItem: BorderLobbyItem,
  getManifestProcessingStrategy: getBaseManifestProcessingStrategy(
    StylesDerivedNativeActions.borderStyles,
  ),
  groupDisplayFilter: borderGroupDisplayFilter,
  comparisonMode: ComparisonMode.ValueSet,
  valueSetValueFilter: ({ propertyType, value }) => {
    // Only filter border widths; keep colors/styles untouched for ValueSet grouping.
    if (!BORDER_WIDTH_CSS_PROPERTY_TYPES.includes(propertyType as any)) {
      return true;
    }
    return Meaningfulness.isMeaningfulValue(
      StylesDerivedNativeActions.borderStyles,
      value,
      propertyType,
    );
  },
  grouping: borderGrouping,
};

export default borderAction;
